// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { invRecipeId } from './InvRecipe';
import { invWaterKindEnum } from './InvWaterKindEnum';
import { z } from 'zod';
export const invProductionId = (z.number());
export const invProduction = z.object({
    id: invProductionId,
    recipe_id: invRecipeId.nullable(),
    output_item_id: z.number().transform((val) => val),
    operator_id: z.number().nullable(),
    water_type: invWaterKindEnum.nullable(),
    created_at: z.date().nullable(),
    performed_at: z.date().nullable(),
    note: z.string().nullable(),
});
export const invProductionInitializer = z.object({
    id: invProductionId.optional(),
    recipe_id: invRecipeId.optional().nullable(),
    output_item_id: z.number().transform((val) => val),
    operator_id: z.number().optional().nullable(),
    water_type: invWaterKindEnum.optional().nullable(),
    created_at: z.date().optional().nullable(),
    performed_at: z.date().optional().nullable(),
    note: z.string().optional().nullable(),
});
export const invProductionMutator = z.object({
    id: invProductionId.optional(),
    recipe_id: invRecipeId.optional().nullable(),
    output_item_id: z.number().transform((val) => val).optional(),
    operator_id: z.number().optional().nullable(),
    water_type: invWaterKindEnum.optional().nullable(),
    created_at: z.date().optional().nullable(),
    performed_at: z.date().optional().nullable(),
    note: z.string().optional().nullable(),
});
//# sourceMappingURL=InvProduction.js.map